import { Image } from "react-bootstrap";
import { FaFilm, FaTrophy, FaGlobe, FaFlag } from "react-icons/fa";
import SEO from "../../components/seo";

const stats = [
    { icon: <FaFilm size={28} />, number: "15", label: "Filmes Produzidos" },
    { icon: <FaTrophy size={28} />, number: "100+", label: "Prêmios" },
    { icon: <FaGlobe size={28} />, number: "200+", label: "Festivais" },
    { icon: <FaFlag size={28} />, number: "18", label: "Países" },
];

const SobreNos = () => {

    return (
        <div className="sobre-nos-page bg-white">
            <SEO
                title="Sobre Nós"
                description="Conheça a Abdução Filmes, produtora de cinema independente de Belo Horizonte, MG. Fundada em 2020, com filmes premiados em festivais como Berlinale, Gramado e Telluride."
                path="/sobre-nos"
            />

            {/* Hero Section */}
            <div className="sobre-nos-hero position-relative text-center">
                <Image
                    src={require('./sobre-nos.jpg')}
                    alt="Equipe da Abdução Filmes"
                    className="sobre-nos-hero-img"
                />
    
            </div>

            {/* Stats Section */}
            <div className="bg-dark text-white py-4">
                <div className="container">
                    <div className="row text-center g-3">
                        {stats.map((stat, i) => (
                            <div className="col-6 col-md-3" key={i}>
                                <div className="py-3">
                                    <div className="mb-2 text-white-50">{stat.icon}</div>
                                    <div className="fs-2 fw-bold">{stat.number}</div>
                                    <div className="small text-white-50">{stat.label}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* About Section */}
            <div className="container py-4 py-md-5">
                <div className="row">
                    <div className="col-lg-8 mx-auto">
                        <h2 className="text-center mb-4">Quem Somos</h2>
                        <p className="text-justify" style={{textIndent: '2rem'}}>
                            A Abdução Filmes é uma produtora independente fundada oficialmente em 2020, em Belo Horizonte (MG),
                            por Marcelo Lin, Marco Antonio Pereira e Rodrigo R. Meireles. Em 2026, Bruno Hilário passa a integrar
                            a sociedade como produtor executivo.
                        </p>
                        <p className="text-justify" style={{textIndent: '2rem'}}>
                            A produtora desenvolve filmes de ficção, documentário e híbridos, marcados pela relação com o território,
                            pela escuta e por processos de criação construídos em diálogo com as comunidades e personagens que retrata.
                        </p>
                        <p className="text-justify" style={{textIndent: '2rem'}}>
                            Em cinco anos de atuação, seus filmes acumulam mais de 200 seleções oficiais e 100 prêmios em festivais
                            como Berlinale, Telluride, Hot Docs, Festival de Brasília, Mostra de Cinema de Tiradentes, FICValdivia,
                            Festival Internacional de Cine en Guadalajara, Festival de Gramado e Festival do Rio, além de
                            licenciamentos para Canal Brasil, Sesc e ARTE.
                        </p>
                        <p className="text-justify" style={{textIndent: '2rem'}}>
                            Em 2026, a produtora lança seu primeiro longa-metragem, Paisagem de Inverno, projeto desenvolvido no
                            Brasil CineMundi, onde recebeu o Troféu Horizonte de Melhor Projeto (2023), conquistou três prêmios no
                            Cinéma en Construction – Cinélatino Rencontres de Toulouse (2025) e foi contemplado com o Prêmio Sesc
                            em Minas – Work in Progress, durante a Conexão Brasil CineMundi, na Mostra de Cinema de Tiradentes
                            (2026). No mesmo ano, retorna ao Brasil CineMundi com o projeto Sobrevivente de Guerra, dando
                            continuidade à trajetória de desenvolvimento de longas-metragens que marca a atuação da produtora.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SobreNos;
